import * as moment from "moment";
import {BillEventApiDto} from "../../../api/model/rest";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import {IconColor} from "../../../hiberUiKit/src/molecules/StreamItem/StreamItemIcon";
import Attachment from "../../attachment/Attachment";
import ActivityEvent from "../../event/ActivityEvent";
import BillUpdatedEvent from "./BillUpdatedEvent";

/**
 * Bill event model.
 */
export default class BillEvent extends ActivityEvent {
	/**
	 * @param {string} id identifier of event.
	 * @param {BillEventTypeEnum} type type of the event.
	 * @param {AuthenticatedEntity} creator entity which created the event.
	 * @param {moment.Moment} creationDateTime creation date of event.
	 */
	constructor(public readonly id: string,
		public readonly type: BillEventTypeEnum,
		public readonly creator: AuthenticatedEntity,
		public readonly creationDateTime: moment.Moment) {
		super();
	}

	getCssClass() {
		return '';
	}

	getIcon() {
		switch (this.type) {
			case BillEventTypeEnum.BillPaid:
				return Icon.Finance;
			default:
				return Icon.New;
		}
	}

	getIconColor(): IconColor {
		return IconColor.Blue;
	}

	getAttachments(): Attachment[] {
		return [];
	}

	getActivityAdditionalMessages(): string[] {
		return [];
	}

	getActivityType(): string {
		return `BILL`;
	}

	getCreationDate(): moment.Moment {
		return this.creationDateTime;
	}

	getActivityMessage(): string {
		switch (this.type) {
			case BillEventTypeEnum.BillPaid:
				return "Bill has been paid";
			case BillEventTypeEnum.NewBillInXeroCreated:
				return "New Bill in Xero has been created";
			default:
				return "Bill has been created";
		}
	}

	getId() {
		return this.id;
	}

	/**
	 * Get user display name.
	 */
	getUserDisplayName(): string {
		return this.creator.getDisplayName();
	}

	public static fromJson(json: BillEventApiDto): BillEvent {
		const creator = AuthenticatedEntity.fromJson(json.creator);
		return new BillEvent(json.id, json.type, creator, moment(json.creationDateTime));
	}
}

export enum BillEventTypeEnum {
	Payment = "PAYMENT",
	Note = "NOTE",
	BillCreated = "BILL_CREATED",
	BillUpdated = "BILL_UPDATED",
	BillPaid = "BILL_PAID",
	NewBillInXeroCreated = "NEW_XERO_INVOICE_CREATED"
}

export type BillEventType = BillEvent | BillUpdatedEvent;
